// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1G-u7","description":"PatientConsentPreview_description__1a_8J"};